export default __webpack_public_path__ + "static/media/maoRed.0355f5ae.svg";